import React from "react";

const ImportIcon16pxSvg = ({
    color = "#1F2937",
    width = 16,
    height = 16,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M10.1733 14.8342H5.82667C2.55333 14.8342 1.15333 13.4342 1.15333 10.1608V10.0742C1.15333 7.11416 2.32 5.6875 4.93333 5.44083C5.2 5.42083 5.45333 5.62083 5.48 5.89416C5.50667 6.1675 5.30667 6.41416 5.02667 6.44083C2.93333 6.63416 2.15333 7.62083 2.15333 10.0808V10.1675C2.15333 12.8808 3.11333 13.8408 5.82667 13.8408H10.1733C12.8867 13.8408 13.8467 12.8808 13.8467 10.1675V10.0808C13.8467 7.6075 13.0533 6.62083 10.92 6.44083C10.6467 6.41416 10.44 6.17416 10.4667 5.90083C10.4933 5.6275 10.7267 5.42083 11.0067 5.4475C13.66 5.67416 14.8467 7.1075 14.8467 10.0875V10.1742C14.8467 13.4342 13.4467 14.8342 10.1733 14.8342Z" fill={color} />
            <path d="M8 10.4207C7.72667 10.4207 7.5 10.194 7.5 9.92065V1.33398C7.5 1.06065 7.72667 0.833984 8 0.833984C8.27333 0.833984 8.5 1.06065 8.5 1.33398V9.92065C8.5 10.2007 8.27333 10.4207 8 10.4207Z" fill={color} />
            <path d="M8 11.1672C7.87333 11.1672 7.74667 11.1205 7.64667 11.0205L5.41333 8.78721C5.22 8.59388 5.22 8.27388 5.41333 8.08055C5.60667 7.88721 5.92667 7.88721 6.12 8.08055L8 9.96055L9.88 8.08055C10.0733 7.88721 10.3933 7.88721 10.5867 8.08055C10.78 8.27388 10.78 8.59388 10.5867 8.78721L8.35333 11.0205C8.25333 11.1205 8.12667 11.1672 8 11.1672Z" fill={color} />
        </svg>
    );
};

export default ImportIcon16pxSvg;